import { makeStyles } from "@material-ui/core/styles";
import { Workouts } from "app-interfaces";
import React from "react";
import { useTranslation } from "react-i18next";

import { useStateValue } from "../../../config/AppContext";
import CatalogClass from "../../../models/Catalog";
import { ScoreTypeName } from "../../../types/StaticTypes";
import { ExerciseDetailsComponent as ExerciseDetails } from "../../Exercises";
import Table from "../Table";

const useStyles = makeStyles((theme) => ({
  drawerTab: {
    width: "25vw",

    "& .tabDiv2": {
      width: "44vw",
      marginTop: "1rem",
    },
  },
}));

type TabProps = {
  currentTab?: number;
  exerciseIndex: number;
  exercise: Workouts.IExercise;
  mystyle?: boolean | undefined;
};

const TabComponent: React.FC<TabProps> = ({ currentTab, exerciseIndex, exercise, mystyle }) => {
  const { catalog } = useStateValue() as { catalog: CatalogClass };
  const { t } = useTranslation();
  const classes = useStyles();
  if (!catalog) return <></>;
  const exerciseItem = catalog.findExercise(exercise.exercise_id);

  if (!exerciseItem)
    return (
      <div className="tab" style={{ width: "25vw" }}>
        <h5 className="section-heading">{t("Exercise not found")}</h5>
      </div>
    );

  return window.innerWidth > 700 ? (
    <div className={`tab ${mystyle && classes.drawerTab}`} style={{ width: "25vw" }}>
      {/* <div className='tabDiv1'> */}
      <h5
        className="section-heading"
        style={{ color: "#333333", fontWeight: "bold", marginLeft: "0.5%" }}
      >
        {exerciseItem.name}
      </h5>

      {/* </div>
      <div className='tabDiv2'> */}
      <ExerciseDetails match={{ params: exercise }} mystyle={true}>
        <Table
          exercise={exercise}
          index={exerciseIndex + 1}
          currentTab={currentTab}
          exerciseItem={exerciseItem}
        />
      </ExerciseDetails>
      {/* </div> */}
    </div>
  ) : (
    <div className={`tab ${mystyle && classes.drawerTab}`} style={{ width: "25vw" }}>
      <h5
        className="section-heading"
        style={{ color: "#333333", fontWeight: "bold", marginLeft: "1.5%" }}
      >
        {exerciseItem.name}
      </h5>
      <ExerciseDetails match={{ params: exercise }} mystyle={true}>
        <Table
          exercise={exercise}
          index={exerciseIndex + 1}
          currentTab={currentTab}
          exerciseItem={exerciseItem}
        />
      </ExerciseDetails>
    </div>
  );
};

export default TabComponent;

// All possible input names we can have in the form (depending on which score types user added)
type InputFieldName = "score_type" | "exercise_notes" | "notes_sets" | ScoreTypeName;
export type ExerciseInputsData = Record<InputFieldName, string[]>;

const getTabElement = (tabIndex: number) => {
  const tabs = document.querySelectorAll(".tab") as NodeListOf<HTMLElement>;
  return tabs.item(tabIndex);
};

const getTabInputElements = (tabIndex: number) => {
  return getTabElement(tabIndex).querySelectorAll(
    "input.form-control"
  ) as NodeListOf<HTMLInputElement>;
};

/**
 * Collect inputs data from the current tab DOM, because Table.tsx provides no other way to get the data.
 *
 * The data looks like this:
 * {
 *   exercise_notes: [''],
 *   notes_sets: ['', '', ''],
 *   score_type: ['TIME']
 *   INCLINE: ['3', '4', '5'],
 *   PAUSE: ['2', '3', '4'],
 *   PULSE_ZONE: ['6', '7', '8'],
 *   TIME: ['1', '2', '3'],
 *   WATT: ['8', '9', '10'],
 * }
 *
 * Fields like "INCLINE" may be present based on exercise type (e.g. "CARDIO" exercise), and if the user chose to add these scores.
 *
 * Number of values for the score types depends on number of sets the user added for this exercise.
 */
export const getTabInputsData = (tabIndex: number) => {
  const tabInputs = getTabInputElements(tabIndex);
  const inputsData = {} as ExerciseInputsData;
  tabInputs.forEach((tabInput) => {
    const tabInputName = tabInput.name as InputFieldName;
    if (!inputsData[tabInputName]) {
      inputsData[tabInputName] = [tabInput.value];
    } else {
      inputsData[tabInputName].push(tabInput.value);
    }
  });

  inputsData.score_type = [tabInputs[0].name];
  return inputsData;
};

/**
 * Get input element corresponding to the given scoreType and scoreColumnIndex.
 * It's used to toggle validation classes, as Table.tsx is in pure JS.
 */
export const getScoreInput = (tabIndex: number, scoreType: string, scoreColumnIndex: number) => {
  const tabElement = getTabElement(tabIndex);
  const scoreInputs = tabElement.querySelectorAll(`input[name="${scoreType}"]`);
  return scoreInputs.item(scoreColumnIndex);
};
